import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AiSearchPatternView } from "./AiSearchPatternView";
import { AiSearchPatternViewStore } from "../../store/AiSearchPatternViewStore";
import { useStore } from "../../../../hooks";

export const AiSearchPatternViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/aiSearchPattern/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AiSearchPatternViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AiSearchPatternView aiSearchPatternViewStore={store} />
      </PageLayout>
    </div>
  );
});
